import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "panel"]

  toggle() {
    const hidden = this.panelTarget.classList.toggle("d-none")
    this.buttonTarget.setAttribute("aria-expanded", !hidden)
  }
}
